"use strict";
// src/ts/main.ts
exports.__esModule = true;
var application_1 = require("./application");
require("../scss/main.scss");
document.addEventListener('DOMContentLoaded', function (event) {
    var application = new application_1.Application();
    application.run();
});
